import Cookies from 'js-cookie';
import globalEnum from '../../enums/globalEnum';
import { useAppSelector } from "../../services/store";
import userRole = globalEnum.userRole;

export const Sidebar = () => {
  const userReducer = useAppSelector(state => state.userReducer);
  return (
    <aside className="sideBarContainer">
      <div className="sideBar">
        <div className="pic"></div>
        <i className="basketSvg"></i>
        <i className="productSvg activSvg"></i>
        <i className="usersSvg activSvg"></i>
        <i className="categorySvg"></i>
        <i className="menuSvg"></i>
        <i className="tagSvg"></i>
        <i className="brandSvg"></i>
        <i className="articleSvg"></i>
        <i className="categorySvg"></i>
        <i className="infoSvg"></i>
        <i className="sidBarExit clickable" onClick={() => {
          Cookies.remove('token');
          window.location.reload();
        }}></i>
      </div>
      <div className="adminInfoContainer">
      <span className="admininfo">
        <i className="adminSvg"></i>
        <div className="adminNameSection">
          <h6 className="adminName">{userReducer?.profile?.name}</h6>
          <p className="adminTitle">ادمین</p>
        </div>
      </span>
        <a href="/Order" className="sideBarTitle">
          سفارشات
        </a>

        {userReducer?.profile?.role == userRole.superAdmin &&
            <>
                <a href="/analytics" className="sideBarTitle">
                    داشبورد
                </a>
                <a href="/Product" className="sideBarTitle">
                    محصولات
                </a>
                <a href="/Product/prices" className="sideBarTitle">
                    لیست قیمت
                </a>
                <a href="/User" className="sideBarTitle">
                    کاربران
                </a>
                <a href="/sms" className="sideBarTitle">
                    پیامک و نوتیف
                </a>    
                  <a href="/Product/inventory" className="sideBarTitle">
                    مدیریت انبار
                </a>
                <a href="/Shelves" className="sideBarTitle">
                    قفسه‌های انبار
                </a>
              {/* <a href="/Role" className="sideBarTitle"> */}
              {/* نقش ها */}
              {/* </a> */}
                <a href="/Category" className="sideBarTitle">
                    دسته بندی ها
                </a>
                {/* <a href="/Menu" className="sideBarTitle">
                    منوها
                </a> */}
                <a href="/Car" className="sideBarTitle">
                    ماشین ها
                </a>
                <a href="/Tag" className="sideBarTitle">
                    تگ
                </a>
                {/* <a href="/Brand" className="sideBarTitle">
                    برند
                </a> */}
                {/* <a href="/DashBlog" className="sideBarTitle">
                    مقالات
                </a>
                <a href="/Banner" className="sideBarTitle">
                    کارت ها
                </a> */}
                <a href="/Attribute" className="sideBarTitle">
                    لیست مشخصات فنی
                </a>
                <a href="/AttributeGroup" className="sideBarTitle">
                    دسته بندی مشخصات
                </a>
                {/* <a href="/AttributeValue" className="sideBarTitle1">
                    لیست مقادیر مشخصات فنی
                </a> */}
            </>
        }
      </div>
    </aside>
  );
};